import * as React from 'react'
import { observer } from 'mobx-react'
import { injectStores, StoreComponent } from '../../store'
import { runInAction, observable } from 'mobx'
import { ContentMenuText, ContentMenuTextTypes } from '../storydoc/storydocStoreContent'

import * as styles from './impressum.css'

interface IContentMenu {
  type: ContentMenuTextTypes
}

@injectStores
@observer
export class ContentMenu extends StoreComponent<IContentMenu> {
  @observable.ref impressum: ContentMenuText | null = null

  constructor (props: any, context: any) {
    super(props, context)
    this.fetchImpressum()
  }

  async fetchImpressum () {
    const impressum = await this.store.storyDocContent.fetchContentMenuText(this.props.type)
    runInAction(() => {
      this.impressum = impressum
    })
  }

  componentDidUpdate (oldprops: any) {
    if (this.props.type !== oldprops.type) {
      this.fetchImpressum()
    }
  }

  render () {
    let impressumText = this.impressum && this.impressum.textHtml || ''
    if (this.store.breakpoints.phone) {
      impressumText = impressumText.replace(/\|/g, '<br>')
    }

    return (
      <div className={styles.contentBox}>
        <div className={ styles.content }>
          <div className={styles.contributorsList} dangerouslySetInnerHTML={{ __html: impressumText }}/>
          <div className={styles.footer}>
            { this.impressum && this.impressum._data.logo_link_1.url && <a href={this.impressum._data.logo_link_1.url} target='_blank'><img className={styles.footerImage} src={this.impressum._data.logo_link.url} alt='footer_icon'/></a>}
            { this.impressum && this.impressum._data.logo_link_2.url && <a href={this.impressum._data.logo_link_2.url} target='_blank'><img className={styles.footerImage} src={this.impressum._data.logo_2.url} alt='footer_icon'/></a>}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/imprintSources/impressum.tsx